import { CustomerRepository } from "core/repository";
import CustomerFormCreatePresenter from "./create.presenter";

class CustomerFormEditPresenter extends CustomerFormCreatePresenter {
  initialState() {
    return {
      ...super.initialState(),
      creating: false,
      title: "Editar Cliente"
    };
  }

  async onStart() {
    this.customerUuid = this.routeParams.customerUuid;
    await super.onStart();
  }

  async getCustomer() {
    return await CustomerRepository.get(this.customerUuid);
  }

  async callRepository(params) {
    return await CustomerRepository.update(this.customerUuid, params);
  }
}

export default CustomerFormEditPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/form/edit.presenter.js